//es-disable-next-line @typescript-eslint/explicit-module-boundary-types
export function applyTheme(config: { branding: any }): void {
  const branding: any = config.branding || {};
  for (const key in branding) {
    if (branding.hasOwnProperty(key)) {
      document.documentElement.style.setProperty(`${key}`, branding[key]);
    }
  }
}
